<template>
  <div class="modal_slide_up">

    <transition name="modal_fade">
      <Modal v-if="showComponents" @click.native="closeModalSlideUp(), $store.commit('navBarMinimised', false)"></Modal>
    </transition>

    <transition name="slideUp_slide">
      <SlideUp v-if="showComponents">
        <slot></slot>
      </SlideUp>
    </transition>

  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'
import SlideUp from '@/components/SlideUp2.vue'

export default {
  props: [
    'showComponents',
  ],
  components: {
    Modal,
    SlideUp,
  },
  data: function () {
    return {
    }
  },
  methods: {
    closeModalSlideUp() {
      this.$emit('updateStatus');
    }
  },
  computed: {
  }
}
</script>


<style scoped>
/*MODAL TRANSITIONS*/
.modal_fade-enter-active, .modal_fade-leave-active {
  transition: 0.3s opacity ease;
}
.modal_fade-enter, .modal_fade-leave-to {
  opacity: 0;
}
.slideUp_slide-enter-active, .slideUp_slide-leave-active {
  transition: 0.3s transform ease;
}
.slideUp_slide-enter, .slideUp_slide-leave-to {
  transform: translateY(100%);
}
</style>
